import { ImageViewer } from 'features/image/components/ImageViewer';

export const ImageViewerPage = () => {
    return (
        <ImageViewer />
    );
};
